import { Routes, Route } from 'react-router-dom';
import ExplorePage from '../pages/ExplorePage';
import TaskPage from '../pages/TaskPage';
import TaskDetailPage from '../pages/TaskDetailPage';
import CardDetailPage from '../pages/CardDetailPage';
import AssetsPage from '../pages/AssetsPage';
import PersonalInfoPage from '../pages/personal-info';
import ProposalSquarePage from '../pages/ProposalSquarePage';
import FindFriendsPage from '../pages/FindFriendsPage';
import ProposalDetailPage from '../pages/ProposalDetailPage';
import FindFriendDetailPage from '../pages/FindFriendDetailPage';
import WorkspacePage from '../pages/WorkspacePage';
import FindIdeasPage from '../pages/FindIdeasPage';
import DocumentListPage from '../pages/DocumentListPage';
import SearchResultsPage from '../pages/SearchResultsPage';

// Child routes for tasks
const taskRoutes = [
  {
    path: '/tasks/detail/:id',
    name: '提案详情',
    element: <TaskDetailPage />, 
  },
];

// Card routes
const cardRoutes = [
  {
    path: '/cards/detail/:id',
    name: '卡片详情',
    element: <CardDetailPage />,
  },
  {
    path: '/explore/detail/:id',
    name: '卡片详情',
    element: <CardDetailPage />,
  },
];

const mainRoutes = [
  {
    path: '/',
    name: '首页',
    element: <ExplorePage />,
  },
  {
    path: '/explore',
    name: '探索',
    element: <ExplorePage />,
  },
  {
    path: '/explore/proposals',
    name: '提案广场',
    element: <ProposalSquarePage />,
  },
  {
    path: '/explore/proposals/:id',
    name: '提案详情',
    element: <ProposalDetailPage />,
  },
  {
    path: '/explore/friends',
    name: '找队友',
    element: <FindFriendsPage />,
  },
  {
    path: '/explore/friends/:id',
    name: '找队友详情',
    element: <FindFriendDetailPage />,
  },
  {
    path: '/explore/ideas',
    name: '找点子',
    element: <FindIdeasPage />,
  },
  {
    path: '/tasks',
    name: '提案',
    element: <TaskPage />,
  },
  {
    path: '/assets',
    name: '资产',
    element: <AssetsPage />,
  },
  {
    path: '/personal-info/:id',
    name: '个人中心',
    element: <PersonalInfoPage />,
  },
  {
    path: '/workspace/:id',
    name: '工作台',
    element: <WorkspacePage />,
  },
  {
    path: '/documents',
    name: '文档',
    element: <DocumentListPage />,
  },
  {
    path: '/search',
    name: '搜索',
    element: <SearchResultsPage />,
  },
];

// Combine them
const allRoutes = [...mainRoutes, ...taskRoutes, ...cardRoutes];

// Export for RouteTracker
export { allRoutes };

export default function AppRouter() {
  return (
    <Routes>
      {allRoutes.map((route, index) => (
        <Route key={index} path={route.path} element={route.element} />
      ))}
    </Routes>
  );
}
